<template>
  <div class="container contenedorVista">
    <form-validator class="form">
      <wrap-container>
        <h1>Ingresá tus datos y compartí el link con tus clientes</h1>
        <wrap-container class="referidos-container">
          <wrap-container>
            <number-input
              label="DNI"
              hint="Ingresá tu DNI"
              v-model="cuit"
              :required="true"
              maxlength="11"
            />
          </wrap-container>
          <wrap-container>
            <text-input label="Nombre" v-model="razonSocial" :required="true" />
          </wrap-container>
          <wrap-container>
            <sales-button
              class="button"
              label="Obtener link"
              v-on:click="doGetLink"
            />
          </wrap-container>
        </wrap-container>
        <modal-component
          :show="showModal"
          buttonLabel="Copiar link"
          label="Tu link para compartir"
          @close="copyLink"
        >
          <textarea rows="5" ref="textarea" :value="link" readonly />
        </modal-component>
      </wrap-container>
    </form-validator>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import SalesButton from "@/components/core/SalesButton";
import TextInput from "@/components/core/TextInput";
import FormValidator from "@/components/core/FormValidator";
import NumberInput from "@/components/core/NumberInput.vue";
import ModalComponent from "@/components/core/ModalComponent.vue";
import { DO_NOTIFICATION_TOAST } from "@/config/constants/action-types";

export default {
  name: "Referidos",
  components: {
    FormValidator,
    WrapContainer,
    SalesButton,
    TextInput,
    NumberInput,
    ModalComponent
  },

  data() {
    return {
      razonSocial: "",
      cuit: "",
      showModal: false
    };
  },
  computed: {
    link() {
      return (
        "https://apps.bbva.com.ar/openmarket/contacto-empresas/?origen=" +
        this.$route.params.origen +
        "&refe=" +
        encodeURIComponent(window.btoa(this.cuit))
      );
    }
  },
  methods: {
    doGetLink() {
      this.showModal = true;
    },
    copyLink() {
      try {
        const textArea = this.$refs.textarea;
        textArea.select();
        document.execCommand("Copy");
        this.$store.dispatch(DO_NOTIFICATION_TOAST, {
          type: "success",
          message: "Se copió el link con éxito!"
        });
        this.showModal = false;
      } catch (error) {
        console.error(error);
        this.$store.dispatch(DO_NOTIFICATION_TOAST, {
          type: "alert",
          message: "No se pudo copiar, copie manualmente."
        });
      }
    }
  }
};
</script>

<style scoped>
.contenedorVista {
  margin: 0;
  background: url("../assets/img/1x/deco-meeting.svg");
  background-size: contain;
  background-position: right center;
  background-repeat: no-repeat;
}
.referidos-container {
  max-width: 480px;
}
h1 {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  color: #121212;
  line-height: 1.33;
  font-size: 36px;
  font-weight: 500;
  margin-top: 0;
  letter-spacing: -0.4px;
  max-width: 600px;
}
textarea {
  display: block;
  width: 100%;
  border: 0;
  resize: none;
}

.contenedorVista {
  max-width: 1176px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 60px;
  padding-bottom: 60px;
  padding-left: 17px;
  padding-right: 17px;
  box-sizing: border-box;
}

@media (max-width: 1200px) {
  /* For mobile phones: */
  .contenedorVista {
    max-width: 960px;
  }
}

@media (max-width: 600px) {
  /* For mobile phones: */
  .contenedorVista {
    display: block;
    padding-top: 40px;
    padding-bottom: 40px;
  }
}

@media (max-width: 900px) {
  .contenedorVista {
    background: none;
  }
}
</style>
